<template>
  <div class="prestore">
    <div class="title text-no">
      <div class="flex1">
        <div
          class="tabs"
          :class="tab == 1 ? 'tabBorder' : ''"
          @click="cutover(1)"
        >
          基本情况
        </div>
        <div
          class="tabs"
          :class="tab == 2 ? 'tabBorder' : ''"
          @click="cutover(2)"
        >
          未核销
        </div>
        <div
          class="tabs"
          :class="tab == 3 ? 'tabBorder' : ''"
          @click="cutover(3)"
        >
          消费记录
        </div>
        <div
          class="tabs"
          :class="tab == 4 ? 'tabBorder' : ''"
          @click="cutover(4)"
        >
          充值记录
        </div>
      </div>
    </div>
    <div class="main">
      <basicInformation v-if="tab == 1"></basicInformation>
      <noVerification v-if="tab == 2"></noVerification>
      <expenseCalendar v-if="tab == 3"></expenseCalendar>
      <rechargeRecord v-if="tab == 4"></rechargeRecord>

    </div>
  </div>
</template>

<script>
import expenseCalendar from "./component/expenseCalendar.vue";
import basicInformation from "./component/basicInformation.vue";
import noVerification from "./component/noVerification.vue";
import rechargeRecord from "./component/rechargeRecord.vue";
import { paths } from '../../utils/pathNew.js'
export default {
  data() {
    return {
      tab: window.sessionStorage.getItem("prestore") == null? (window.localStorage.getItem("prestore") == null? 1 : window.localStorage.getItem("prestore")) : window.sessionStorage.getItem("prestore"),
    };
  },
  components: {
    expenseCalendar,
    basicInformation,
    noVerification,
    rechargeRecord,
  },
  methods: {
    cutover(i) {
      if (i == this.tab) return;
      this.tab = i;
      window.localStorage.setItem("prestore", i);
      window.sessionStorage.setItem("prestore", i);
    },
  },
  created(){
    // Tab 导航栏 样式跟随
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
  }
};
</script>

<style lang="less">
.prestore {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #f7f7f8ff;

  .title {
    display: flex;
    justify-content: center;
    height: 46px;
    line-height: 44px;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    border: 1px solid #ececec;
    background-color: #fff;
    .flex1 {
      display: flex;
      cursor: pointer;
      .tabs {
        width: 64px;
        margin-right: 48px;
        &:hover {
          color: #008cffff;
          border-bottom: 2px solid #008cffff;
          max-width: 64px;
        }
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    margin: 16px 24px 16px 24px;
    background-color: #fff;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
  }
}
.tabBorder {
 // color: #000;
  border-bottom: 2px solid #008cffff;
  color:#008cffff ;
}
</style>